// extracted by mini-css-extract-plugin
export default {"cover_screen":"loading_cover_screen__-7itQ","loading":"loading_loading__OnEUL","text":"loading_text__TKrpy","icon":"loading_icon__QpWFQ","spin":"loading_spin__OW+R2"};